import React, { useEffect, useState, useMemo } from 'react';
import styled from 'styled-components';
import * as api from '../../../api'
import { Link } from 'react-router-dom';
import CompaniesList from './CompaniesList';
import CompanyAdminFields from './CompanyAdminFields';
import dayjs from 'dayjs';
import DesignersList from './DesignersList';
import { exportCSVPopA, exportCSVPopADetailed, exportCSVPopB, exportCSVPopBDetailed } from '../CSVExporter';
import Spinner from '../../../Plateforme/Atoms/Spinner';

// ========== Shortlist Table Styles ==========
const TableWrapper = styled.div`
    overflow-x: auto;
    margin-top: 16px;
`;
const STable = styled.table`
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
    th, td { padding: 8px 10px; border-bottom: 1px solid #E5E7EB; text-align: left; vertical-align: top; }
    th { background: #F3F4F6; font-weight: 700; color: #374151; position: sticky; top: 0; cursor: pointer; user-select: none; white-space: nowrap; }
    th:hover { background: #E5E7EB; }
    tr:hover td { background: #F9FAFB; }
`;
const StatusSelect = styled.select`
    padding: 4px 8px; border-radius: 6px; font-size: 12px; font-weight: 600; border: 1px solid #D1D5DB; cursor: pointer;
    background: ${p => p.value === 'green' ? '#D1FAE5' : p.value === 'red' ? '#FEE2E2' : p.value === 'purple' ? '#EDE9FE' : '#F3F4F6'};
    color: ${p => p.value === 'green' ? '#065F46' : p.value === 'red' ? '#991B1B' : p.value === 'purple' ? '#5B21B6' : '#374151'};
`;
const FilterBar = styled.div`
    display: flex; gap: 12px; align-items: center; margin-bottom: 12px; flex-wrap: wrap;
    select, input { padding: 6px 10px; border: 1px solid #D1D5DB; border-radius: 6px; font-size: 13px; }
    input { min-width: 200px; }
`;
const SaveNotice = styled.span`
    color: #059669; font-size: 11px; font-weight: 600; margin-left: 6px;
`;
const MessageCell = styled.td`
    max-width: 300px; white-space: pre-wrap; word-break: break-word; color: #555; font-size: 12px;
`;

const Shortlists = () => {

    const [event, setEvent] = useState(null);
    const [pannel, setPannel] = useState("companieslist")
    const [popBselected, setPopBselected] = useState("")
    const [selectedUser, setSelectedUser] = useState(null);
    const [selectedDesigner, setSelectedDesigner] = useState(null);
    const [allParticipations, setAllParticipations] = useState([]);

    const [planning, setPlanning] = useState(null);

    //parse eid from url
    useEffect(() => {
        const eventIdFromParam = new URLSearchParams(window.location.search).get("eid");
        if (eventIdFromParam) {
            api.getEventById({ id: eventIdFromParam }).then((response) => {
                response.data.displaytype = (response.data.type === "sde" || response.data.type === "sdo") ? "Speed Dating" : "Le FD100";
                console.log(response.data);
                setEvent(response.data);
            }).catch((error) => {
                console.log(error);
            });
        }
    }, [])

    // get all participations
    useEffect(() => {
        if (!event) return;
        getAllParticipations()
    }, [event])
    function getAllParticipations(){
        api.getParticipatingUsersWithData({ eventId: event._id }).then((response) => {
            console.log("response.data de get all participations");
            console.log(response.data);
            setAllParticipations(response.data);
        }).catch((error) => {
            console.log(error);
        });
    }

    //keep selected user in state
    useEffect(() => {
        if (selectedUser) {
            setSelectedUser(allParticipations.find(participation => participation.user._id === selectedUser.user._id))
        }
        if (selectedDesigner) {
            setSelectedDesigner(allParticipations.find(participation => participation.user._id === selectedDesigner.user._id))
        }
    }, [allParticipations])

    async function manualAddProfile(data) {
        try{
            const response = await api.addProfileManual(data)
            console.log(response.data);
            if(response.data === "already manual profile with this email for this event"){
                alert("Erreur : un profil ajouté manuellement existe déjà avec cet email pour cet événement. Le profil n'a pas été ajouté.");
            }else{
                getAllParticipations();
            }
        }catch(err){
            console.log(err);
        }
    }

    useEffect(() => {
        if (!event) return;
        api.GetPlanning({ eventId: event._id }).then((response) => {
            console.log("response.data de get planning");
            console.log(response.data);
            setPlanning(response.data);
        }).catch((error) => {
            console.log(error);
        });
    }, [event])

    const exportShortlistsCSV = () => {
        const popACompanies = allParticipations.filter(p => p.participation.type[3] === 'a');
        const popBDesigners = allParticipations.filter(p => p.participation.type[3] === 'b');
        const rows = [['Entreprise', 'Designer', 'Email designer', 'Téléphone', 'Statut', 'Priorité', 'Message candidature']];

        popACompanies.forEach(company => {
            const companyName = company.hsCompany?.properties?.name || company.user?.email || '';
            const sl = company.shortlist || { valide: [], refuse: [], enattente: [] };
            const allIds = [...(sl.valide || []), ...(sl.enattente || []), ...(sl.refuse || [])];

            allIds.forEach(partId => {
                const designer = popBDesigners.find(d => d.participation._id === partId);
                if (!designer) return;
                const designerName = designer.hsCompany?.properties?.name || designer.participation?.data?.companyname || designer.user?.email || '';
                const designerEmail = designer.user?.email || '';
                const designerPhone = designer.participation?.data?.phone || '';
                let status = 'À traiter';
                if (sl.valide?.includes(partId)) status = 'Confirmé';
                else if (sl.refuse?.includes(partId)) status = 'Refusé';
                else if (sl.enattente?.includes(partId)) status = 'En attente';
                const candidature = designer.candidatures?.find(c => c.participationId === company.participation._id);
                const priority = candidature?.priorite ?? '';
                const message = (candidature?.message || '').replace(/"/g, '""').replace(/\n/g, ' ');
                rows.push([companyName, designerName, designerEmail, designerPhone, status, priority, message].map(v => `"${v}"`));
            });
        });

        const csvContent = 'data:text/csv;charset=utf-8,' + rows.map(r => r.join(',')).join('\n');
        const link = document.createElement('a');
        link.setAttribute('href', encodeURI(csvContent));
        link.setAttribute('download', 'shortlists_export.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    // ========== Shortlist Table View ==========
    const [tableFilter, setTableFilter] = useState('all'); // all, green, red, purple, lightgrey
    const [tableSearch, setTableSearch] = useState('');
    const [savedRow, setSavedRow] = useState(null);
    const [sortCol, setSortCol] = useState('company');
    const [sortDir, setSortDir] = useState('asc');

    const shortlistRows = useMemo(() => {
        const popA = allParticipations.filter(p => p.participation.type[3] === 'a');
        const popB = allParticipations.filter(p => p.participation.type[3] === 'b');
        const rows = [];

        popA.forEach(company => {
            const companyName = company.hsCompany?.properties?.name || company.user?.email || '';
            const sl = company.shortlist || { valide: [], refuse: [], enattente: [] };

            // Get all designers who have candidatures for this company OR are in shortlist
            const relevantDesigners = popB.filter(d => {
                const hasCandidature = d.candidatures?.some(c => c.participationId === company.participation._id);
                const inShortlist = sl.valide?.includes(d.participation._id) || sl.refuse?.includes(d.participation._id) || sl.enattente?.includes(d.participation._id);
                return hasCandidature || inShortlist;
            });

            relevantDesigners.forEach(designer => {
                const partId = designer.participation._id;
                let color = 'lightgrey';
                if (sl.valide?.includes(partId)) color = 'green';
                else if (sl.refuse?.includes(partId)) color = 'red';
                else if (sl.enattente?.includes(partId)) color = 'purple';

                const candidature = designer.candidatures?.find(c => c.participationId === company.participation._id);
                rows.push({
                    companyPartId: company.participation._id,
                    companyName,
                    designerPartId: partId,
                    designerName: designer.hsCompany?.properties?.name || designer.participation?.data?.companyname || designer.user?.email || '',
                    designerEmail: designer.user?.email || '',
                    designerPhone: designer.participation?.data?.phone || '',
                    color,
                    priority: candidature?.priorite ?? '',
                    message: candidature?.message || '',
                    company, // ref for saving
                });
            });
        });
        return rows;
    }, [allParticipations]);

    const filteredRows = useMemo(() => {
        let rows = shortlistRows;
        if (tableFilter !== 'all') rows = rows.filter(r => r.color === tableFilter);
        if (tableSearch) {
            const q = tableSearch.toLowerCase();
            rows = rows.filter(r => r.companyName.toLowerCase().includes(q) || r.designerName.toLowerCase().includes(q) || r.designerEmail.toLowerCase().includes(q));
        }
        rows = [...rows].sort((a, b) => {
            let va = a[sortCol] ?? '', vb = b[sortCol] ?? '';
            if (typeof va === 'string') va = va.toLowerCase();
            if (typeof vb === 'string') vb = vb.toLowerCase();
            if (va < vb) return sortDir === 'asc' ? -1 : 1;
            if (va > vb) return sortDir === 'asc' ? 1 : -1;
            return 0;
        });
        return rows;
    }, [shortlistRows, tableFilter, tableSearch, sortCol, sortDir]);

    const handleSort = (col) => {
        if (sortCol === col) setSortDir(d => d === 'asc' ? 'desc' : 'asc');
        else { setSortCol(col); setSortDir('asc'); }
    };
    const sortArrow = (col) => sortCol === col ? (sortDir === 'asc' ? ' ↑' : ' ↓') : '';

    const handleStatusChange = async (row, newColor) => {
        const company = row.company;
        const sl = { ...(company.shortlist || { valide: [], refuse: [], enattente: [] }) };
        sl.valide = (sl.valide || []).filter(id => id !== row.designerPartId);
        sl.refuse = (sl.refuse || []).filter(id => id !== row.designerPartId);
        sl.enattente = (sl.enattente || []).filter(id => id !== row.designerPartId);
        if (newColor === 'green') sl.valide.push(row.designerPartId);
        else if (newColor === 'red') sl.refuse.push(row.designerPartId);
        else if (newColor === 'purple') sl.enattente.push(row.designerPartId);

        try {
            await api.UpsertShortlist(company.participation._id, sl);
            // Update local state
            setAllParticipations(prev => prev.map(p => {
                if (p.participation._id === company.participation._id) {
                    return { ...p, shortlist: sl };
                }
                return p;
            }));
            setSavedRow(`${row.companyPartId}-${row.designerPartId}`);
            setTimeout(() => setSavedRow(null), 2000);
        } catch (err) {
            alert('Erreur lors de la sauvegarde');
            console.log(err);
        }
    };

    const statusCounts = useMemo(() => {
        const counts = { green: 0, red: 0, purple: 0, lightgrey: 0 };
        shortlistRows.forEach(r => counts[r.color]++);
        return counts;
    }, [shortlistRows]);

    console.log(planning)

    return (
        <div>
            {event ?
                <div>
                    <Link to="/admin/events"><button>← Retour au panneau d'administration</button></Link><br/><br/>
                    <h1>{event.title_fr}</h1>
                    <h2>{new dayjs(event.main_date).format('dddd D MMMM YYYY')}</h2>
                    {pannel === "companieslist" && <>
                        <br/>
                        <div className='flexinfos'>
                            <button style={{float:"left"}} onClick={() => exportCSVPopA(allParticipations.filter(participation => participation.participation.type[3] === "a"),"popa.csv")}>Export CSV</button>
                            <button style={{float:"left"}} onClick={() => exportCSVPopADetailed(allParticipations.filter(participation => participation.participation.type[3] === "a"),"popadetailed.csv")}>Export CSV détaillé</button>
                            <button style={{float:"left"}} onClick={exportShortlistsCSV}>Export Shortlists CSV</button>
                            <button style={{float:"left", background: '#2563EB', color: 'white', border: 'none', padding: '6px 16px', borderRadius: 6, cursor: 'pointer', fontWeight: 600}} onClick={() => setPannel("shortlisttable")}>Vue tableau Shortlists</button>
                            {/* <button onClick={()=>window.open("planning?eid="+event._id)}>Voir le planning</button> */}
                        </div>
                        <br/>
                        <div className='flexinfos numbers'>
                            <span className='tooltip'><b onClick={() => {setPannel("designerslist");setPopBselected("Inscriptions")}}>{allParticipations.filter(participation => (participation.participation.type[3] === "b") && participation.candidatures.length === 0 ).length}</b>
                            <span className='tooltiptext'>inscriptions pop B avec 0 candidature</span></span>
                            <span className='tooltip'><b onClick={() => {setPannel("designerslist");setPopBselected("Candidats")}}>{allParticipations.filter(participation => (participation.participation.type[3] === "b") && participation.candidatures.length > 0 ).filter(participation => !planning?.data.find(rdv => rdv.designerParticipationId === participation.participation._id)).length} </b>
                            <span className='tooltiptext'>inscriptions pop B avec 1 ou plusieurs candidatures et 0 rdvs attribués</span></span> 
                            <span className='tooltip'><b onClick={() => {setPannel("designerslist");setPopBselected("Participants")}}>{allParticipations.filter(participation => (participation.participation.type[3] === "b") && participation.candidatures.length > 0 ).filter(participation => planning?.data.find(rdv => rdv.designerParticipationId === participation.participation._id)).length} </b>
                            <span className='tooltiptext'>inscriptions pop B avec 1 ou plusieurs rdvs attribués</span></span> 
                            <b>{planning?.data.length}</b>
                        </div>
                        <div className='flexinfos'>
                            <p>Inscriptions</p>
                            <p>Candidats</p>
                            <p>Participants</p>
                            <p>Rendez-vous</p>
                        </div>
                        <CompaniesList 
                            event={event}
                            companies={allParticipations.filter(participation => participation.participation.type[3] === "a")}
                            setPannel={setPannel}
                            setSelectedUser={setSelectedUser}
                            participants={allParticipations.filter(participation => participation.participation.type[3] === "b")}
                        />
                        
                    </>}
                    {pannel === "companyeditoradmin" && selectedUser && <>
                        <CompanyAdminFields participation={selectedUser.participation} userDescription={selectedUser.hsCompany?.properties?.description_courte_fr} onBack={()=>setPannel("companieslist")} onFinnish={()=>{setPannel("companieslist");getAllParticipations()}}/>
                    </>}
                    {pannel === "shortlisttable" && <>
                        <br/>
                        <button onClick={() => setPannel("companieslist")}>← Retour</button>
                        <h3 style={{ margin: '16px 0 8px' }}>Vue tableau — Shortlists ({shortlistRows.length} lignes)</h3>
                        <FilterBar>
                            <input type="text" placeholder="Rechercher entreprise ou designer..." value={tableSearch} onChange={e => setTableSearch(e.target.value)} />
                            <select value={tableFilter} onChange={e => setTableFilter(e.target.value)}>
                                <option value="all">Tous ({shortlistRows.length})</option>
                                <option value="green">Confirmés ({statusCounts.green})</option>
                                <option value="purple">En attente ({statusCounts.purple})</option>
                                <option value="lightgrey">À traiter ({statusCounts.lightgrey})</option>
                                <option value="red">Refusés ({statusCounts.red})</option>
                            </select>
                            <button style={{float:"right"}} onClick={exportShortlistsCSV}>Export CSV</button>
                        </FilterBar>
                        <TableWrapper>
                            <STable>
                                <thead>
                                    <tr>
                                        <th onClick={() => handleSort('companyName')}>Entreprise{sortArrow('companyName')}</th>
                                        <th onClick={() => handleSort('designerName')}>Designer{sortArrow('designerName')}</th>
                                        <th onClick={() => handleSort('designerEmail')}>Email{sortArrow('designerEmail')}</th>
                                        <th onClick={() => handleSort('designerPhone')}>Tél.{sortArrow('designerPhone')}</th>
                                        <th onClick={() => handleSort('color')}>Statut{sortArrow('color')}</th>
                                        <th onClick={() => handleSort('priority')}>Priorité{sortArrow('priority')}</th>
                                        <th>Message</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredRows.map(row => {
                                        const rowKey = `${row.companyPartId}-${row.designerPartId}`;
                                        return (
                                            <tr key={rowKey}>
                                                <td><strong>{row.companyName}</strong></td>
                                                <td>{row.designerName}</td>
                                                <td><a href={`mailto:${row.designerEmail}`}>{row.designerEmail}</a></td>
                                                <td>{row.designerPhone}</td>
                                                <td>
                                                    <StatusSelect value={row.color} onChange={e => handleStatusChange(row, e.target.value)}>
                                                        <option value="lightgrey">À traiter</option>
                                                        <option value="green">Confirmé</option>
                                                        <option value="purple">En attente</option>
                                                        <option value="red">Refusé</option>
                                                    </StatusSelect>
                                                    {savedRow === rowKey && <SaveNotice>✓</SaveNotice>}
                                                </td>
                                                <td>{row.priority}</td>
                                                <MessageCell>{row.message}</MessageCell>
                                            </tr>
                                        );
                                    })}
                                    {filteredRows.length === 0 && (
                                        <tr><td colSpan={7} style={{ textAlign: 'center', color: '#999', padding: 24 }}>Aucun résultat</td></tr>
                                    )}
                                </tbody>
                            </STable>
                        </TableWrapper>
                    </>}
                    {pannel === "designerslist" && <>
                        <br/>
                        <br/>
                        <button onClick={() => setPannel("companieslist")} className=''>← Retour</button><br/><br/>
                        <button style={{float:"right"}} onClick={() => exportCSVPopB(popBselected === "Inscriptions" ? allParticipations.filter(participation => participation.participation.type[3] === "b").filter(p => p.candidatures.length === 0) : allParticipations.filter(participation => participation.participation.type[3] === "b").filter(p => p.candidatures.length > 0),popBselected + ".csv",allParticipations.filter(participation => participation.participation.type[3] === "a"))}>Export CSV</button><br/><br/>
                        <button style={{float:"right"}} onClick={() => exportCSVPopBDetailed(popBselected === "Inscriptions" ? allParticipations.filter(participation => participation.participation.type[3] === "b").filter(p => p.candidatures.length === 0) : allParticipations.filter(participation => participation.participation.type[3] === "b").filter(p => p.candidatures.length > 0),popBselected + "detailed.csv",allParticipations.filter(participation => participation.participation.type[3] === "a"))}>Export CSV détaillé</button>
                        <DesignersList 
                            event={event}
                            companies={allParticipations.filter(participation => participation.participation.type[3] === "a")}
                            setPannel={setPannel}
                            setSelectedUser={setSelectedUser}
                            participants={popBselected === "Inscriptions" ? allParticipations.filter(participation => participation.participation.type[3] === "b").filter(p => p.candidatures.length === 0) : (popBselected === "Candidats" ? allParticipations.filter(participation => participation.participation.type[3] === "b").filter(p => p.candidatures.length > 0).filter(participation => !planning?.data.find(rdv => rdv.designerParticipationId === participation.participation._id)) : allParticipations.filter(participation => participation.participation.type[3] === "b").filter(p => p.candidatures.length > 0).filter(participation => planning?.data.find(rdv => rdv.designerParticipationId === participation.participation._id)))}
                            manualAddProfile={manualAddProfile}
                        />
                    </>}
                </div>
            :
                <Spinner/>
            }
        </div>
    );
};

export default Shortlists;